<template>
  <div class="info">
    <div class="info-top">
      <div class="info-top__name">采购方信息</div>
      <div class="info-top__subtitle">(备注：这里的采购方信息通常指的是您们的公司信息，如果是个人卖家可以只输入采购人信息；该采购方信息在后续的"采购合同"生成时将自动导出，将提升您的管理效率及数据一体化效果)</div>
    </div>
    <div class="info-module">
      <template v-for="item in inputBox">
        <template v-if="item.type === 'location'">
          <div class="info-module__list" :key="item.data + 0">
            <div class="info-module__name">
              <span class="info-module__list--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
            </div>
            <div class="info-module__input">
              <el-select size="mini" placeholder="省份"></el-select>
            </div>
          </div>
          <div class="info-module__list" :key="item.data + 1">
            <div class="info-module__name"></div>
            <div class="info-module__input">
              <el-select size="mini" placeholder="城市"></el-select>
            </div>
          </div>
          <div class="info-module__list" :key="item.data + 2">
            <div class="info-module__name"></div>
            <div class="info-module__input">
              <el-select size="mini" placeholder="区"></el-select>
            </div>
          </div>
          <div class="info-module__list" :key="item.data + 3">
            <div class="info-module__name"></div>
            <div class="info-module__input">
              <el-input size="mini" placeholder="详细信息"></el-input>
            </div>
          </div>
        </template>
        <template v-else-if="item.type === 'textarea'">
          <div class="info-module__list info-module__list--textarea" :key="item.data">
            <div class="info-module__name">
              <span class="info-module__list--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
            </div>
            <div class="info-module__input">
              <el-input size="mini" type="textarea" :placeholder="item.pla" resize="none" rows="3"></el-input>
            </div>
          </div>
        </template>
        <template v-else>
          <div class="info-module__list" :key="item.data">
            <div class="info-module__name">
              <span class="info-module__list--star" v-if="item.isRequired">*</span>
              {{ item.name }}:
            </div>
            <div class="info-module__input">
              <el-input size="mini" :placeholder="item.pla"></el-input>
            </div>
          </div>
        </template>
      </template>
      <div class="info-module-bottom">
        <div class="info-module-bottom__btn">保存</div>
      </div>
    </div>
  </div>
</template>

<script>
import { PurchaseNewModule } from './class'
export default {
  name: 'purchaserInformation',
  data(){
    return {
      inputBox: PurchaseNewModule.NEWINFOINPUTBOX()
    }
  }
}
</script>

<style lang="scss" scoped>
.info{
  width: 1500px;
  &-top{
    display: flex;
    align-items: end;
    border-bottom: 1px solid #d7d7d7;
    padding-bottom: 5px;
    margin: 10px 20px;
    &__name{
      font-weight: bold;
      font-size: 16px;
      color: black;
    }
    &__subtitle{
      color: #fca605;
      font-size: 12px;
      margin-left: 5px;
    }
  }
  &-module{
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-top: 50px;
    height: 500px;
    &__list{
      display: flex;
      justify-content: end;
      align-items: center;
      margin: 5px 0;
      width: 500px;
      ::v-deep{
        .el-input__inner{
          width: 300px;
        }
        .el-textarea__inner{
          width: 300px;
          border-radius: 0;
        }
      }
      &--star{
        color: red;
      }
      &--textarea{
        align-items: start;
        .info-module__name{
          margin-top: 8px;
        }
      }
    }
    &__name{
      margin: 0 10px;
      text-align: end;
      width: 150px;
      font-size: 12px;
    }
    &-bottom{
      display: flex;
      justify-content: end;
      width: 500px;
      &__btn{
        line-height: 30px;
        padding: 0 30px;
        color: white;
        background: #00a0c7;
        margin-left: 10px;
        &:hover{
          cursor: pointer;
          opacity: .8;
        }
      }
    }
  }
}
</style>
